import React from 'react'
import PropTypes from 'prop-types'

import StoryPointsOptions from "./options-popover-component"
import PopupMenuButton from "src/core/gd-components/popover-menu/popup-menu-button/popup-menu-button"
import HintPopover from "src/core/gd-ui/hint-popover/hint-popover"

const _getValue = (props, state) => {
    let res;
    if (!_.isNil(state.value)) res = state.value
    else if (props.form)       res = props.form.getValue(props.name)
    else                       res = props.value

    return res;
}

export default class StoryPointsComponentProto extends React.Component {

    static propTypes = {
        renderMode  : PropTypes.oneOf(['list','view', 'icon']).isRequired,
        value       : PropTypes.any,

        form        : PropTypes.object,
        name        : PropTypes.string,

        hint        : PropTypes.string,

        canEdit     : PropTypes.bool,

        onChange    : PropTypes.func,
        onRemove    : PropTypes.func
    }

    static defaultProps = {
        canEdit     : true,
    }

    constructor(props) {
        super(props)

        const value = _getValue(props, {})
        this.state = {
            initialValue: value,
            value       : value
        }
    }

    static getDerivedStateFromProps(props, state) {
        const value = _getValue(props, {})
        if (value !== state.initialValue) {
            return {
                initialValue: value,
                value       : value,
            }
        }
        return null
    }

    onSelect = (value) => {
        this.setState({
            value: value
        }, ()=>{
            if (this.props.form) this.props.form.onFormComponentValueChange(this.props.name, value);
            if (this.props.onChange) this.props.onChange(value);
        })
    }

    onDelete = () => {
        this.onSelect(null);
        if (this.props.onRemove) this.props.onRemove();
    }

    onTogglePopover = (value) => {
        this.popoverShown = value;
        this.forceUpdate();
    }

    renderButtonComponent = () => {
        const options = gd.session.companies.get(gd.companyId).settings.fields.storyPoints;

        const value = _getValue(this.props, this.state)
        let valueLabel = 'Select';

        if (!_.isNil(value)) {
            const found = _.find(options, option=>option.value === value);
            valueLabel = found ? found.label : value;
        }

        let res;
        switch (this.props.renderMode) {
            case 'list':

                if (value) {
                    // ui5-pill-22
                    res = <div className="field-holder">{valueLabel}</div>;
                } else {
                    res = <div className="field-holder ui5-txt-less-important-small ui5-txt-undeline-16">Story points</div>;
                }
                break;

            case 'view':
                /*res = (
                    <React.Fragment>
                        <div className="field-holder ui5-pill-22 no-border">{valueLabel}</div>
                        {!_.isNil(value) && <dis className="i5-delete-circle-solid delete-button" onClick={this.onDelete}/>}
                    </React.Fragment>
                );*/

                const classes = Classes("ui5-story-points s-24",{
                    'disabled': !this.props.canEdit,
                    'not-set': _.isNil(value)
                })

                res = (
                    <React.Fragment>
                        <div className={classes}>{!_.isNil(value) ? valueLabel : ''}</div>
                        {!_.isNil(value) && this.props.canEdit && <div className="i5-delete-circle-solid delete-button m-l-10" onClick={this.onDelete}/>}

                        {this.props.hint && !this.popoverShown && <HintPopover parent={this} hint={this.props.hint}/>}
                    </React.Fragment>
                );
                break;
            case 'icon': {
                const curValueClasses = Classes('ui5-circle-selector', {
                    'no-value': _.isNil(value)
                });

                res = (
                    <div className={curValueClasses}>
                        <div className="icon i5-story-points"/>
                        {this.props.hint && !this.popoverShown && <HintPopover parent={this} hint={this.props.hint}/>}
                    </div>
                );
            } break;
        }

        return res;
    }

    render() {
        const value = _getValue(this.props, this.state)
        const classes = Classes('gd-field-story-points', this.props.renderMode, this.props.className, {
            'not-set': _.isNil(value)
        });

        return (
            <PopupMenuButton className={classes}
                             btnComponent={this.renderButtonComponent}
                             attachment="top center"
                             targetAttachment="bottom center"
                             offset="0 0"
                             disabled={this.props.canEdit === false}
                             menuComponent={StoryPointsOptions}
                             menuParams={{
                                 value,
                                 onSelect:  this.onSelect
                             }}
                             onTogglePopover={this.onTogglePopover}/>
        );
    }
}
